import { jsx as _jsx } from "react/jsx-runtime";
import OneTimePaymentInEligible from './OneTimePaymentInEligible';
import PaymentDelinquent from './PaymentDelinquent';
const paymentNotAllowedTypes = {
    DELINQUENT_ACCOUNT: 'delinquentAccount',
    ONE_TIME_PAYMENT_NOT_ELIGIBLE: 'oneTimePaymentNotEligible'
};
const PaymentNotAllowed = ({ mainMachineCurrentState }) => {
    const { open: { paymentNotAllowed } } = mainMachineCurrentState;
    if (paymentNotAllowed === paymentNotAllowedTypes.DELINQUENT_ACCOUNT) {
        return _jsx(PaymentDelinquent, {});
    }
    if (paymentNotAllowed === paymentNotAllowedTypes.ONE_TIME_PAYMENT_NOT_ELIGIBLE) {
        return _jsx(OneTimePaymentInEligible, {});
    }
    throw new Error('Invalid value of paymentNotAllowed variable');
};
export default PaymentNotAllowed;
